import {
  i
} from "./chunk.FAJKIEWS.js";

// src/components/jb-contact-overlay/jb-contact-overlay.css.ts
var jb_contact_overlay_css_default = i`:host{background-color:#fff;display:block;min-height:100%;padding-bottom:126px;padding-top:42px}@media(min-width: 600px){:host{padding-top:12px}}@media(min-width: 1281px){:host{padding-top:2px}}iframe{border:0;height:0;width:100%}`;

export {
  jb_contact_overlay_css_default
};
